import { Injectable } from '@angular/core';
import { WindowRef } from '@trademe/tangram';
import { TmWindow } from './tm-window.interface';

@Injectable()
export class BrowserCapabilitiesService {
    private readonly _window: TmWindow;
    constructor(windowRef: WindowRef<TmWindow>) {
        this._window = windowRef.useWindow((window) => window);
    }

    public supportsFileReaderApi(): boolean {
        return !!(
            this._window &&
            this._window.File &&
            this._window.FileList &&
            this._window.FileReader
        );
    }
}
